import { Schema } from "effect";
import * as z from "zod";
import { AccountId, ConversationId, SupportTicketId } from "./definitions";

const isSupportTicketId = Schema.is(SupportTicketId);
const isConversationId = Schema.is(ConversationId);
const isAccountId = Schema.is(AccountId);

/**
 * Zod schema whose output is the Effect-branded {@link AccountId}. Validation
 * is delegated to the Effect schema (pass-through, no transform), so the format
 * lives in one place and the parsed value is usable directly where the branded
 * Effect type is expected.
 */
export const AccountIdZod = z.custom<AccountId>((value) => isAccountId(value), {
  error: () => `Must be an AccountId (${AccountId.prefix}_<base62>)`,
});

/**
 * Zod schema whose output is the Effect-branded {@link SupportTicketId}.
 * Validation is delegated to the Effect schema, so the format lives in one
 * place ({@link SupportTicketId}) and the parsed value is usable directly in
 * code that expects the branded Effect type.
 */
export const SupportTicketIdZod = z.custom<SupportTicketId>(
  (value) => isSupportTicketId(value),
  {
    error: () =>
      `Must be a SupportTicketId (${SupportTicketId.prefix}_<base62>)`,
  },
);

/**
 * Zod schema whose output is the Effect-branded {@link ConversationId}
 * (alias of `TopicId`). Validation is delegated to the Effect schema.
 */
export const ConversationIdZod = z.custom<ConversationId>(
  (value) => isConversationId(value),
  {
    error: () => `Must be a ConversationId (${ConversationId.prefix}_<base62>)`,
  },
);
